// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanel from 'viewmodel/AwPanelViewModel';
import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import DesLibraryProperties from 'viewmodel/DesLibraryPropertiesViewModel';
import DesLibraryPreview from 'viewmodel/DesLibraryPreviewViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "imports": [],
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "collaborationspaceid": {
            "type": "string"
        },
        "libraryid": {
            "type": "string"
        }
    },
    "lifecycleHooks": {
        "onUpdate": {
            "observers": [
                "props.accsessionid",
                "props.collaborationspaceid",
                "props.libraryid"
            ]
        }
    },
    "_viewModelId": "DesListLibraryOverview",
    "_uniqueViewModelId": "DesListLibraryOverview",
    "ctx": {}
};

    /*
    <aw-panel>
    <aw-panel-body class="des-library-overview">
        <aw-flex-row>
            <aw-flex-column width="6">
                <des-library-properties accsessionid={{props.accsessionid}} libraryid={{props.libraryid}}
                    collaborationspaceid="{{props.collaborationspaceid}}">
                </des-library-properties>
            </aw-flex-column>
            <aw-flex-column width="6">
                <des-library-preview accsessionid={{props.accsessionid}} libraryid={{props.libraryid}}
                    collaborationspaceid="{{props.collaborationspaceid}}">
                </des-library-preview>
            </aw-flex-column>
        </aw-flex-row>
    </aw-panel-body>
</aw-panel>
    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
                <AwPanel  revealAction={actions.reveal}>
        <AwPanelBody className="des-library-overview">
            <AwFlexRow>
                <AwFlexColumn width="6">
                    <DesLibraryProperties accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} libraryid={AwParseService.instance( "props.libraryid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} collaborationspaceid={AwParseService.instance( "props.collaborationspaceid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    </DesLibraryProperties>
                </AwFlexColumn>
                <AwFlexColumn width="6">
                    <DesLibraryPreview accsessionid={AwParseService.instance( "props.accsessionid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} libraryid={AwParseService.instance( "props.libraryid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )} collaborationspaceid={AwParseService.instance( "props.collaborationspaceid" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}>
                    </DesLibraryPreview>
                </AwFlexColumn>
            </AwFlexRow>
        </AwPanelBody>
    </AwPanel>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;